import {
  EnhancedTableHeader,
  EnhancedTableHeaderType
} from '@components/table/widgets/shared-with-old';

export const paymentsTableHeaders: Record<string, EnhancedTableHeader> = {
  referenceNumber: {
    name: 'referenceNumber',
    title: 'Reference',
    type: EnhancedTableHeaderType.Text
  },
  totalPremium: {
    name: 'totalPremium',
    title: 'Total Premium',
    type: EnhancedTableHeaderType.RoundedCurrency
  },
  totalPremiumReceived: {
    name: 'totalPremiumReceived',
    title: 'Amount Received',
    type: EnhancedTableHeaderType.RoundedCurrency
  },
  totalPremiumBalance: {
    name: 'totalPremiumBalance',
    title: 'Outstanding Receivable Amount',
    type: EnhancedTableHeaderType.RoundedCurrency
  },
  totalCommission: {
    name: 'totalCommission',
    title: 'Total Commission',
    type: EnhancedTableHeaderType.RoundedCurrency
  },
  taxOnCommissionAmount: {
    name: 'taxOnCommissionAmount',
    title: 'Total Tax on Commission',
    type: EnhancedTableHeaderType.RoundedCurrency
  },
  totalCommissionPaid: {
    name: 'totalCommissionPaid',
    title: 'Amount Paid',
    type: EnhancedTableHeaderType.RoundedCurrency
  },
  totalCommissionBalance: {
    name: 'totalCommissionBalance',
    title: 'Outstanding Payable Amount',
    type: EnhancedTableHeaderType.RoundedCurrency
  },
  balance: {
    name: 'balance',
    title: 'Balance',
    type: EnhancedTableHeaderType.RoundedCurrency,
    disableSort: true
  },
  viewInstallments: {
    name: 'viewInstallments',
    title: '',
    type: EnhancedTableHeaderType.Clickable,
    callback: () => undefined // wired in component
  }
};
